"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpDefEnabledRendererFactory = void 0;
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useOpDefinitionUpdate_1 = __importDefault(require("@opsbase/react-gql-hooks/opdefinition/useOpDefinitionUpdate"));
const Switch_1 = __importDefault(require("@opsbase/web-ui/Switch"));
const react_1 = __importStar(require("react"));
const OpDefEnabledRendererFactory = () => (opDefinition) => {
    var _a;
    const [loading, setLoading] = (0, react_1.useState)(false);
    const updateOpDefinition = (0, useOpDefinitionUpdate_1.default)();
    const self = (0, useSelf_1.default)();
    const isEditable = self.isPrimary ||
        self.isSuperUser ||
        !!((_a = opDefinition === null || opDefinition === void 0 ? void 0 : opDefinition.editorStaff) === null || _a === void 0 ? void 0 : _a.find(z => z.id === self.id)) ||
        !((opDefinition === null || opDefinition === void 0 ? void 0 : opDefinition.lockEditingToPrimaryAdmins) || (opDefinition === null || opDefinition === void 0 ? void 0 : opDefinition.lockEditing));
    const disabled = !isEditable || !(opDefinition.permitAdhoc || opDefinition.scheduled);
    const handleEnableToggle = (0, react_1.useCallback)(onOff => {
        setLoading(true);
        requestAnimationFrame(() => __awaiter(void 0, void 0, void 0, function* () {
            yield updateOpDefinition({
                id: opDefinition.id,
                patch: { enabled: onOff },
            });
            setLoading(false);
        }));
    }, [opDefinition.id, updateOpDefinition]);
    if (!opDefinition)
        return;
    return (react_1.default.createElement(Switch_1.default, { small: true, loading: loading, disabled: disabled, onChange: handleEnableToggle, checked: opDefinition.enabled }));
};
exports.OpDefEnabledRendererFactory = OpDefEnabledRendererFactory;
exports.default = exports.OpDefEnabledRendererFactory;
